// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"cc327c56","containerOuter":"d2c52f53","container":"eb866d52","cardContainer":"b97336c1"};